import React, { Fragment } from 'react';
import { Redirect, Route, withRouter } from 'react-router';
import { Switch } from 'react-router-dom';
import { connect } from 'react-redux';
import ReactGA from 'react-ga';
import './App.scss';
import Login from 'components/web-feature/login/Login';
import Dashboard from './feature/dashboard/Dashboard';
import PrivateRoute from './components/common/PrivateRoute';
import PLP from 'components/web-feature/products/PLP';
import Cart from 'components/web-feature/cart/Cart';
import Demo from './components/common/Demo';
import PDP from 'components/web-feature/products/PDP';
import Category from 'components/web-feature/category/Category';
import Search from 'components/web-feature/search/Search';
import Location from 'components/web-feature/location/Location';
import Home from './components/web-feature/Home';
import LogRocket from 'logrocket';
import config from 'appConfig';
import checkoutRoutes, {
  getCheckoutRoute,
} from 'components/web-feature/checkout/checkout.routes';
import {
  showNonServiceableModal,
  showMergeCartOnLoginModalModal,
  showOrderFailedModal,
  setPreorderModal,
  showLoginModal,
  showLocationMap,
  showLocationSearchModal,
  showAddressListModal,
  showAddressModal,
  setRechargeForOrderModal,
  setPaymentFailModal,
  setPaymentSummaryModal,
  showScratchCardModal,
} from 'hb-redux-store/feature/modal/modal.action';
import {
  getLaunchInfo,
  setAppNotification,
} from 'hb-redux-store/initial.action';
import NonServiceableModal from './components/mweb/Modal/NonServiceableModal';
import history from 'hb-redux-store/history';
import AccountHome from 'components/web-feature/account/AccountHome';
import OrderDetails from 'components/web-feature/account/OrderDetails';
import Loader from './components/mweb/Skeletons/Loader/Loader';
import MergeCartOnLoginModal from './components/mweb/Modal/MergeCartOnLoginModal';
import { mergeOrFlushCart } from 'hb-redux-store/feature/cart/cart.action';
import OrderFailedModal from './components/mweb/Modal/OrderFailedModal';
import FAQList from 'components/web-feature/account/FAQList';
import { initializeMap } from './hb-redux-store/util/locationService';
import SpecialPage from './feature/special-page/SpecialPage';
import OrderForCustomer from './feature/login/OrderForCustomer';
import HeaderComponent from './components/web-feature/Header';
import SimpleModal from './components/mweb/Modal/SimpleModal';
import Notifications from 'components/web-feature/account/Notifications';
import AddAddress from 'components/web-feature/checkout/AddAddress';
import Snackbar from './components/common/Snackbar';
import AddressList from 'components/web-feature/checkout/AddressList';
import { getPDPRoutes } from './feature/products/pdp.routes';
import { getCategoryRoutes } from './feature/category/category.routes';
import Blog from './components/web-feature/blog/Blog';
import BlogNav from './components/web-feature/blog/BlogNav';
import BlogList from './components/web-feature/blog/BlogList';
import BlogSegments from './components/web-feature/blog/BlogSegments';
import AnalyticsService from './AnalyticsService';
import ComboPDP from './components/web/ComboProducts/ComboPDP';
import subscriptionRoutes from './components/web-feature/Subscription/subscription.routes';
import {
  PAYMENT_PENDING,
  SECTIONS_PLP,
} from './hb-redux-store/util/constantServices';
import SectionPLP from './components/web-feature/products/SectionPLP';
import HBMoneyRechargeWeb from './feature/account/Wallet/HBMoneyRechargeWeb';
import Drawer from './components/common/Drawer';
import HBMoney from './feature/account/Wallet/HBMoney';
import OrderSummaryModal from './feature/checkout/OrderSummaryModal';
import { UniversalScratchCardModal } from './App';
import HalalboxPrime from 'components/web-feature/halalbox-prime/HalalboxPrime';
import { HB_PRIME_ROUTE } from 'components/web-feature/Home/constant';
import { getBuyNowTimer } from 'hb-redux-store/util/miscellaneousServices';
import { removeItem } from 'hb-redux-store/util/localStorageService';
class WebApp extends React.Component {
  constructor(props) {
    super(props);
    document.body.classList.add('desktop-container');
    document.head.classList.add('header-container');
    let cb = () => {};
    const windowRef = window || {};
    const HOSTs = ['www.vegxl.in', 'vegxl.in'];
    this.isHbPrime = false;
    if (
      process.env.NODE_ENV === 'production' &&
      HOSTs.indexOf(windowRef.location?.host) > -1
    ) {
      LogRocket.init(process.env.REACT_APP_LOGROCKET_KEY || '2evxox/hb-dev', {
        network: {
          requestSanitizer: request => {
            // if the url contains 'ignore' || razorPay api
            if (
              request.url.toLowerCase().indexOf('ignore') > -1 ||
              request.url.toLowerCase().indexOf('https://api.razorpay.com') > -1
            ) {
              // ignore the request response pair
              console.log('Ignoring body: ', request);
              return {
                url: request.url,
                method: request.method,
                body: {},
                headers: request.headers,
              };
            }
            // otherwise log the request normally
            return request;
          },
        },
      });
      LogRocket.identify(config.getDeviceId());
      cb = traits => {
        LogRocket.identify(config.getDeviceId(), {
          ...traits,
          host: windowRef.location.host,
        });
      };
    }
    this.props.getLaunchInfo(cb);
    AnalyticsService.clevertap.sendCleverTapEvent('web launch');
    window.addEventListener('beforeinstallprompt', event => {
      console.log('User prompted for A2HS');
      ReactGA.event({
        category: 'A2HS',
        action: 'Prompt Shown',
        label: 'desktop',
        nonInteraction: true,
      });
      event.userChoice?.then &&
        event.userChoice.then(choiceResult => {
          console.log('A2HS Result: ', choiceResult.outcome);
          ReactGA.event({
            category: 'A2HS',
            action: choiceResult.outcome,
            label: 'desktop',
            nonInteraction: true,
          });
        });
    });
    window.addEventListener('HARD_RESET', () => {
      // console.log(' === HARD_RESET listened.');
      window.location.reload();
    });
    window.addEventListener('HARD_RESET_REDIRECT', () => {
      console.log(' === HARD_RESET_REDIRECT listened.');
      props.setAppNotification(
        'Something went wrong. Redirecting you to homepage.'
      );
      setTimeout(() => {
        window.location.href = '/';
      }, 500);
    });
  }
  componentDidMount() {
    AnalyticsService.pageView(this.props.location);
    window?.fbq && window.fbq('track', 'PageView');
    history.listen(location => {
      AnalyticsService.pageView(location);
      window?.fbq && window.fbq('track', 'PageView');
      window.scrollTo({ top: 0, behavior: 'smooth' });
    });
  }

  componentDidUpdate() {
    if (this.isHbPrime) {
      document.body.classList.remove('desktop-container');
      document.body.classList.add('hb-prime-container');
    } else if (!this.props?.showMainHeader) {
      document.body.classList.remove('desktop-container');
    } else {
      document.body.classList.remove('hb-prime-container');
      document.body.classList.add('desktop-container');
    }
  }

  createRoutes(feature) {
    return feature.map(route => {
      if (route.isPrivate) {
        return (
          <PrivateRoute {...route} key={route.key} exact={route.isExact} />
        );
      } else {
        return (
          <Route
            exact={route.isExact}
            component={route.component}
            path={route.path}
            key={route.key}
          />
        );
      }
    });
  }

  render() {
    const { initialCheckDone, launchInfo, showMainHeader } = this.props;
    this.isHbPrime = this.props?.location?.pathname === HB_PRIME_ROUTE;

    return (
      <div>
        {showMainHeader && <HeaderComponent location={this.props.location} />}
        {!showMainHeader && <BlogNav />}
        <div
          className={` ${
            this.isHbPrime ? 'hb-prime-container' : 'desktop-container'
          } ${!showMainHeader ? 'blog-container' : ''}`}
        >
          <Snackbar />

          {initialCheckDone && (
            <Fragment>
              <Switch>
                {/*<Route path="/" exact={true} component={Home} />*/}
                <Route path="/" exact={true} component={Home} />
                <PrivateRoute
                  path="/dashboard"
                  exact={true}
                  component={Dashboard}
                />
                <Route
                  path={HB_PRIME_ROUTE}
                  exact={true}
                  component={HalalboxPrime}
                />
                <Route path="/secrets" exact={true} component={Demo} />
                <Route
                  path="/:pageName([A-Za-z0-9_-]+-spl)"
                  exact={true}
                  component={SpecialPage}
                />
                <Route path="/login" exact={true} component={Home} />
                <Route
                  path="/ofc/:cuid/:ccid/:token"
                  exact={true}
                  component={OrderForCustomer}
                />
                {/*<Route path="/ofc/Y0DGVAKVEA/GCGFBN8IJL/d08db935-a11c-4027-a949-2fb60cd5da50" exact={true} component={OrderForCustomer} />*/}
                <Route
                  path="/reset-password/:userUUID/:otp"
                  exact={true}
                  component={Login}
                />
                <Route
                  path="/combo-items/:comboProductId"
                  exact={true}
                  component={ComboPDP}
                />
                <Route
                  path="/invite/:referralCode"
                  exact={true}
                  component={Login}
                />
                <Route path="/cart" exact={false} component={Cart} />
                <Route
                  path="/my/details"
                  exact={true}
                  component={AccountHome}
                />
                <Route path="/search" component={Search} />
                {/* <Route path="/location" component={Location} exact={true} />
                <Route
                  path="/location/:view"
                  component={LocationMap}
                  exact={true}
                /> */}
                {this.createRoutes(checkoutRoutes)}
                {/*{ACCOUNTS_MENU.map(menu => this.createRoutes(menu.subMenu))}*/}
                <PrivateRoute
                  path="/my/addresses"
                  component={AccountHome}
                  exact={true}
                />
                <PrivateRoute
                  path="/co/addresses"
                  component={Cart}
                  exact={true}
                />
                <PrivateRoute
                  path="/my/payments"
                  component={AccountHome}
                  exact={true}
                />
                {/*<PrivateRoute*/}
                {/*  path="/my/halalbox-wallet"*/}
                {/*  component={AccountHome}*/}
                {/*  exact={true}*/}
                {/*/>*/}
                <PrivateRoute
                  path="/my/vxl-money/recharge/:orderNo?"
                  component={HBMoneyRechargeWeb}
                  exact={true}
                />
                <PrivateRoute
                  path="/my/vxl-point"
                  component={AccountHome}
                  exact={true}
                />
                <PrivateRoute
                  path="/my/vxl-point/earn-history"
                  component={AccountHome}
                  exact={true}
                />
                <PrivateRoute
                  path="/my/vxl-money/:amount?"
                  component={AccountHome}
                  exact={true}
                />
                <PrivateRoute
                  path="/my/referrals"
                  component={AccountHome}
                  exact={true}
                  redirectTo="/my/vxl-point"
                />
                <PrivateRoute
                  path="/my/order/:orderNo"
                  component={AccountHome}
                  exact={true}
                />
                <PrivateRoute
                  path="/co/new-address/:addressId?"
                  component={Cart}
                  exact={true}
                />
                <PrivateRoute
                  path="/my/new-address/:addressId?"
                  component={AccountHome}
                  exact={true}
                />
                <Route path="/help/faqs" component={AccountHome} exact={true} />
                <Route
                  path="/help/faqs/:faqTopic"
                  component={AccountHome}
                  exact={true}
                />
                <Route path="/help/tnc" component={AccountHome} exact={true} />
                <Route
                  path="/help/privacy-policy"
                  component={AccountHome}
                  exact={true}
                />
                <Route
                  path="/notifications"
                  component={Notifications}
                  exact={true}
                />
                {this.createRoutes(subscriptionRoutes)}
                <Route path="/blogs" component={BlogList} exact={true} />
                <Route
                  path="/blogs/:segmentTitle/:subcategoryId"
                  component={BlogSegments}
                  exact={true}
                />
                <Route
                  path="/:slug([A-Za-z0-9_-]+-bg)"
                  component={Blog}
                  exact={true}
                />
                {getCategoryRoutes(Category)}
                {getPDPRoutes(PDP)}
                <Route
                  path="/preorder"
                  exact={true}
                  component={p => (
                    <SectionPLP {...p} section={SECTIONS_PLP.PREORDER} />
                  )}
                />
                {/*<Route*/}
                {/*  path="/:categoryName/:productName"*/}
                {/*  exact={true}*/}
                {/*  component={PDP}*/}
                {/*/>*/}

                {/*
                  If route does not match above routes, redirect to homepage
                  Keep this as last route, else any route
                  declared after this wont be rendered.
                */}
                <Redirect to={Home} />
              </Switch>
            </Fragment>
          )}
          {!initialCheckDone && <Loader />}

          <div className="modal-factory">
            <NonServiceableModal
              visible={this.props.nonServiceableModal}
              onCancel={() => {
                this.props.showNonServiceableModal({
                  visible: false,
                  source: null,
                });
              }}
              source={this.props.nonServiceableSource}
              onChangeLocation={() => {
                this.props.showNonServiceableModal({
                  visible: false,
                  source: null,
                });
                this.props.showLocationSearchModal({
                  locationSearchModal: false,
                  typeOfCTA: 'location',
                });
                this.props.showLocationSearchModal({
                  locationSearchModal: true,
                  typeOfCTA: 'location',
                });
                this.props.showLocationMap(false);
                this.props.showAddressListModal(false);
              }}
              launchInfo={launchInfo}
            />
            <MergeCartOnLoginModal
              visible={this.props.mergeCartOnLoginModal}
              onCancel={() => {
                this.props.showMergeCartOnLoginModalModal({
                  mergeCartOnLoginModal: false,
                  source: null,
                });
              }}
              onMergeCartAction={data => {
                const isBuyNow = getBuyNowTimer(config.LSGetItem('isBuyNow'));
                const { mergeCart = false } = data || {};
                data.isBuyNow = isBuyNow;
                let successCb = () => {};
                if (this.props.mergeCartSource === 'CART') {
                  successCb = () => {
                    const paymentLink = getCheckoutRoute('payment');
                    if (!mergeCart && isBuyNow) {
                      removeItem('isBuyNow');
                      history.push(paymentLink);
                    } else if (mergeCart && isBuyNow) {
                      removeItem('isBuyNow');
                      history.push('halalbox-select');
                    } else {
                      history.push('cart');
                    }
                    // history.push(nextUrl.replace('/:addressId?', ''));
                  };
                }
                this.props.mergeOrFlushCart({ ...data, successCb });
              }}
              source={this.props.mergeCartSource}
            />
            <OrderFailedModal
              visible={this.props.orderFailedModal}
              onCancel={() => this.props.showOrderFailedModal(false)}
            />
            <SimpleModal
              visible={this.props.paymentFailModal?.visible}
              onCancel={() =>
                this.props.setPaymentFailModal({ visible: false, reason: null })
              }
              wrapClassName="order-failed-modal"
              title="Payment Failed!"
            >
              <div className="order-failed-modal--content">
                {this.props.paymentFailModal?.reason ===
                  PAYMENT_PENDING.reason && (
                  <React.Fragment>
                    <div className="order-failed-modal--title">
                      Uh-Oh! Your order couldn’t be processed at this time.
                    </div>
                    <div className="order-failed-modal--details">
                      Don’t worry.
                      <br />
                      Any amount deducted will be sent back to the bank account
                      within 5-7 days.
                    </div>
                  </React.Fragment>
                )}
                {this.props.paymentFailModal?.reason !==
                  PAYMENT_PENDING.reason && (
                  <React.Fragment>
                    <div className="order-failed-modal--title">
                      {this.props.paymentFailModal?.reason}
                    </div>
                  </React.Fragment>
                )}
              </div>
            </SimpleModal>
            <SimpleModal
              title={this.props.preorderModal?.title}
              onCancel={() => this.props.setPreorderModal({ visible: false })}
              visible={this.props.preorderModal?.visible}
              wrapClassName="desktop-cvv-modal"
            >
              <div className="desktop-cvv-modal--content">
                {this.props.preorderModal?.content}
              </div>
            </SimpleModal>
            {this.props.loginModal && <Login />}
            {this.props.addressModal && (
              <AddAddress
                prefix="co"
                actionType="new"
                addressId={null}
                showModal={() => this.props.showAddressModal(false)}
              />
            )}
            {this.props.locationSearchModal && <Location path={'/location'} />}
            {this.props.addressListModal && <AddressList />}
            {this.props.rechargeForOrderModal.visible && (
              <Drawer
                title="HALALBOX MONEY"
                placement="right"
                closable={true}
                onClose={() => {
                  this.props.setRechargeForOrderModal({ visible: false });
                  history.replace(
                    this.props.rechargeForOrderModal?.walletProps?.match?.path
                  );
                }}
                visible={this.props.rechargeForOrderModal.visible}
                destroyOnClose={true}
                maskClosable={true}
                width={500}
              >
                <HBMoney {...this.props.rechargeForOrderModal.walletProps} />
              </Drawer>
            )}
            <OrderSummaryModal
              visible={this.props.paymentSummaryModal.visible}
              summary={this.props.paymentSummaryModal.summary}
              onCancel={() =>
                this.props.setPaymentSummaryModal({
                  visible: false,
                  summary: [],
                })
              }
            />
            <UniversalScratchCardModal {...this.props} />
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = ({ initialReducer, modalReducer }) => ({
  initialCheckDone: initialReducer.initialCheckDone,
  launchInfo: initialReducer.launchInfo,
  isLoggedIn: initialReducer.isLoggedIn,
  pingResponse: initialReducer.pingResponse,
  nonServiceableModal: modalReducer.nonServiceableModal,
  mergeCartOnLoginModal: modalReducer.mergeCartOnLoginModal,
  nonServiceableSource: modalReducer.nonServiceableSource,
  mergeCartSource: modalReducer.mergeCartSource,
  orderFailedModal: modalReducer.orderFailedModal,
  preorderModal: modalReducer.preorderModal,
  loginModal: modalReducer.loginModal,
  addressModal: modalReducer.addressModal,
  locationSearchModal: modalReducer.locationSearchModal,
  addressListModal: modalReducer.addressListModal,
  rechargeForOrderModal: modalReducer.rechargeForOrderModal,
  paymentFailModal: modalReducer.paymentFailModal,
  paymentSummaryModal: modalReducer.paymentSummaryModal,
  showMainHeader: initialReducer.showMainHeader,
  scratchCardModal: modalReducer.scratchCardModal,
});

const mapDispatchToProps = {
  getLaunchInfo,
  showNonServiceableModal,
  showMergeCartOnLoginModalModal,
  mergeOrFlushCart,
  showOrderFailedModal,
  setAppNotification,
  setPreorderModal,
  showLoginModal,
  showLocationMap,
  showLocationSearchModal,
  showAddressListModal,
  showAddressModal,
  setRechargeForOrderModal,
  setPaymentFailModal,
  setPaymentSummaryModal,
  showScratchCardModal,
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(WebApp));
